/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Offer_BodyInputs */

const en_us2_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An image sized for stories, with your number and the app's mark.`)
};

const pt_br2_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma imagem no formato dos stories, com o seu número e a marca do app.`)
};

const es_419_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una imagen en formato de historias, con tu número y la marca de la app.`)
};

const pt_pt2_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma imagem no formato das stories, com o teu número e a marca da app.`)
};

const fr_fr2_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une image au format story, avec ton chiffre et la marque de l'appli.`)
};

const de_de2_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Bild im Story-Format, mit deiner Zahl und dem Logo der App.`)
};

const it_it2_share_offer_body = /** @type {(inputs: Share_Offer_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'immagine nel formato delle storie, con il tuo numero e il marchio dell'app.`)
};

/**
* | output |
* | --- |
* | "An image sized for stories, with your number and the app's mark." |
*
* @param {Share_Offer_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_offer_body = /** @type {((inputs?: Share_Offer_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Offer_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_offer_body(inputs)
	if (locale === "es-419") return es_419_share_offer_body(inputs)
	if (locale === "pt-PT") return pt_pt2_share_offer_body(inputs)
	if (locale === "fr-FR") return fr_fr2_share_offer_body(inputs)
	if (locale === "de-DE") return de_de2_share_offer_body(inputs)
	if (locale === "it-IT") return it_it2_share_offer_body(inputs)
	return en_us2_share_offer_body(inputs)
});
export { share_offer_body as "share.offer_body" }